<!-- <ion-app [class.white-background]="isChatIdPresent"> -->
<ion-app>
  <a *ngIf="!chatId" class="logo" href="https://narratheque.io" target="_blank">
    <img src="../assets/logo.svg" alt="Logo" />
  </a>
  <canvas #gradientCanvas id="gradient-canvas"></canvas>
  <ion-router-outlet></ion-router-outlet>
</ion-app>